// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

import {
  backgroundColorPicker,
  titleInput,
  stringInputSpec,
  stringTextAreaSpec,
  anchorIdInput,
} from '../../lib/editing-configs';

// Components
import ThreeSteps from '../three-steps/three-steps';
import SmartButton from '../smart-button/smart-button';

const ThreeSteps2 = ({
  title,
  subtitle,
  titleLevel,
  nameOne,
  nameTwo,
  nameThree,
  iconUriOne,
  iconUriTwo,
  iconUriThree,
  descriptionOne,
  descriptionTwo,
  descriptionThree,
  className,
  backgroundColor,

  buttonType,
  buttonURL,
  buttonText,
  buttonParams,
  successURL,
  authDialogCopyOverrides,
  authDialogImageOverrides,
  anchorId,
  ...smartButtonProps
}) => {
  const button = (
    <SmartButton
      buttonType={buttonType}
      buttonURL={buttonURL}
      buttonText={buttonText}
      buttonParams={buttonParams}
      buttonClass="three-steps__button-cta"
      successURL={successURL}
      authDialogCopyOverrides={authDialogCopyOverrides}
      authDialogImageOverrides={authDialogImageOverrides}
      displayBlock
      {...smartButtonProps}
    />
  );

  return (
    <ThreeSteps
      anchorId={anchorId}
      backgroundColor={backgroundColor}
      title={title}
      subtitle={subtitle}
      titleLevel={titleLevel}
      className={className}
      button={button}
      steps={[
        {
          name: nameOne,
          iconUri: iconUriOne,
          description: descriptionOne,
        },
        {
          name: nameTwo,
          iconUri: iconUriTwo,
          description: descriptionTwo,
        },
        {
          name: nameThree,
          iconUri: iconUriThree,
          description: descriptionThree,
        },
      ]}
    />
  );
};

ThreeSteps2.propTypes = {
  anchorId: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  titleLevel: PropTypes.string,
  nameOne: PropTypes.string,
  nameTwo: PropTypes.string,
  nameThree: PropTypes.string,
  iconUriOne: PropTypes.string,
  iconUriTwo: PropTypes.string,
  iconUriThree: PropTypes.string,
  descriptionOne: PropTypes.string,
  descriptionTwo: PropTypes.string,
  descriptionThree: PropTypes.string,
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
  ...SmartButton.PropTypes,
};

ThreeSteps2.getEditingConfig = (componentDocument) => [
  backgroundColorPicker,
  titleInput,
  stringTextAreaSpec('subtitle', 'Subtitle', {
    help: `Want a hyperlink? Write it like this: [Hi!](www.thing.com).
           NW links should be relative, e.g., [Home](/home)`,
  }),
  stringInputSpec('nameOne', 'First item title'),
  stringTextAreaSpec('iconUriOne', 'First item icon url'),
  stringTextAreaSpec('descriptionOne', 'First item description'),
  stringInputSpec('nameTwo', 'Second item title'),
  stringTextAreaSpec('iconUriTwo', 'Second item icon url'),
  stringTextAreaSpec('descriptionTwo', 'Second item description'),
  stringInputSpec('nameThree', 'Third item title'),
  stringTextAreaSpec('iconUriThree', 'Third item icon url'),
  stringTextAreaSpec('descriptionThree', 'Third item description'),
  ...SmartButton.getEditingConfig(componentDocument),
  anchorIdInput,
];

ThreeSteps2.defaultProps = {
  className: '',
};

export default ThreeSteps2;
